export const MAIN_URI="veetrackerapi/";
